import type { BusinessLineResponse } from '@/lib/types';

interface Props {
  data: BusinessLineResponse | undefined;
  loading: boolean;
  onSelect: (bl: string | null) => void;
  selected: string | null;
}

function pct(n: number, d: number): number {
  if (!d) return 0;
  return Math.round((n / d) * 100);
}

export function BusinessLineTable({ data, loading, onSelect, selected }: Props) {
  const items = data?.items ?? [];

  return (
    <section className="panel">
      <header className="flex items-baseline justify-between border-b border-ink-800 px-6 py-4">
        <div>
          <div className="label">Adopción por filial</div>
          <h2 className="mt-1 text-lg font-light text-ink-50">Ranking comparativo</h2>
        </div>
        {selected ? (
          <button
            type="button"
            onClick={() => onSelect(null)}
            className="text-xs text-ink-400 underline-offset-4 hover:underline"
          >
            Quitar filtro
          </button>
        ) : null}
      </header>
      {loading && items.length === 0 ? (
        <div className="py-12 text-center text-ink-500">Cargando…</div>
      ) : (
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs uppercase tracking-widest text-ink-500">
              <th className="px-6 py-2 font-normal">Filial</th>
              <th className="px-6 py-2 text-right font-normal">Empleados</th>
              <th className="px-6 py-2 text-right font-normal">Licencias</th>
              <th className="px-6 py-2 text-right font-normal">Activos 30d</th>
              <th className="px-6 py-2 font-normal">Adopción</th>
            </tr>
          </thead>
          <tbody>
            {items.map((r) => {
              const adoption = pct(r.active_users, r.licenses);
              const isSelected = selected === r.business_line;
              return (
                <tr
                  key={r.business_line}
                  onClick={() => onSelect(isSelected ? null : r.business_line)}
                  className={`cursor-pointer border-t border-ink-800/60 ${
                    isSelected ? 'bg-ink-900/80' : 'hover:bg-ink-900/40'
                  }`}
                >
                  <td className="px-6 py-3 text-ink-100">{r.business_line}</td>
                  <td className="px-6 py-3 text-right tabular-nums text-ink-400">
                    {r.employees}
                  </td>
                  <td className="px-6 py-3 text-right tabular-nums text-ink-300">
                    {r.licenses}
                  </td>
                  <td className="px-6 py-3 text-right tabular-nums text-ink-200">
                    {r.active_users}
                  </td>
                  <td className="px-6 py-3">
                    <div className="flex items-center gap-3">
                      <div className="relative h-1.5 w-32 bg-ink-800">
                        <div
                          className={`absolute inset-y-0 left-0 ${
                            adoption >= 70
                              ? 'bg-emerald-500'
                              : adoption >= 40
                                ? 'bg-ink-300'
                                : 'bg-red-500'
                          }`}
                          style={{ width: `${adoption}%` }}
                        />
                      </div>
                      <span className="w-10 text-right text-xs tabular-nums text-ink-400">
                        {r.licenses ? `${adoption}%` : '—'}
                      </span>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </section>
  );
}
